// extracted by mini-css-extract-plugin
export default {"popupBody":"EnterDrawPopup__popupBody--fV5","popupButton":"EnterDrawPopup__popupButton--29i"};